<template>
  <div class="bg-black drop-shadow-xl py-1">
    <div
      class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
      <div class="text-white font-medium hidden md:flex text-lg items-center">
        <div class="text-black bg-white rounded-full w-12 h-12 flex justify-center items-center mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10" viewBox="0 0 20 20" fill="currentColor">
            <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
          </svg>
        </div>
        Warenkorb
      </div>
      <div class="text-white text-center hidden sm:flex items-center justify-center">
        KW {{ calendarWeek }} <br>
        {{ startOfWeekFormatted }} - {{ endOfWeekFormatted }}
      </div>
      <div class="flex items-center justify-end">
        <button
          v-if="active"
          class="text-white hover:text-white/80 hover: active:text-white/90"
          @click.prevent="$emit('close')">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <button
          v-else
          class="bg-white text-center text-xs md:text-base text-black hover:bg-white/80 px-4 py-2 font-semibold hover: active:bg-white/90 transition-all"
          :disabled="submitting"
          @click.prevent="$emit('open')">
          Bestellung überprüfen
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import startOfWeek from 'date-fns/startOfWeek'
import endOfWeek from 'date-fns/endOfWeek'
import format from 'date-fns/format'
import getWeek from 'date-fns/getWeek'
import deLocale from 'date-fns/locale/de'

export default {
  name: 'OrderToolbar',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Date,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    startOfWeek() {
      return startOfWeek(this.selected, { weekStartsOn: 1 })
    },

    endOfWeek() {
      return endOfWeek(this.selected, { weekStartsOn: 1 })
    },

    startOfWeekFormatted() {
      return format(this.startOfWeek, 'dd. MMM', {
        locale: deLocale
      })
    },

    endOfWeekFormatted() {
      return format(this.endOfWeek, 'dd. MMM yyyy', {
        locale: deLocale
      })
    },

    calendarWeek() {
      return getWeek(this.selected, { weekStartsOn: 1, locale: deLocale })
    },
  }
}
</script>
